<template>
    <div class="local-video video-edit-con">
        <!-- <video-upload-cloud
            ref="uploaderVideo"
            @addfile="addVideoFile"
            @delVideo="removeFile"
            @completed="uploadVideoCompleted"
            @videoTime="getVideoTime"
        >
        </video-upload-cloud> -->
        <div class="video-uploading" v-show="uploadStatus == 1">
            <label class="video-uploading-btn f-inlineblock-top" for="file-selector" id="video_btn">
                <input class="g-input js-upload-input" type="file" name=""  value="" >
                <p class="btn-text">上传视频</p>
            </label>
            <p class="uploading-prompt f-inlineblock-top">上传视频，可将视频发布到更多媒体哦，单个视频限制2G。</p>
            <input id="file-selector" ref="videoInput" class="f-hide" type="file" accept="video/*" @change="addFile($event)">
        </div>
        <!-- 视频上传中的状态[[ -->
        <div class="video-uploading-block" 
            v-show="uploadStatus == 2"
            v-loading="shacurr"  
            element-loading-spinner="el-icon-loading"
            :element-loading-text="'校验中：'+shacurr+'%'"
        >
            <!-- <div class="shacurr" v-show="shacurr">校验中：{{shacurr}}%</div> -->
            <div class="video-name">{{fileName}}</div>
            <div class="progress-content">
                <div class="progress-bar">
                    <div class="bar" :style="{width: progressBar+'%'}"></div>
                    <div class="progress"></div>
                </div>
                <a href="javascript:;" class="g-btn video-cancel" @click="delVideo()">取消</a>
            </div>
            <div class="progress-tips">
                <span class="tips-name">已上传：</span>
                <span class="tips-content">{{uploadedFileSize}}/{{conver(fileSize)}}</span>
            </div>
            <div class="progress-tips">
                <span class="tips-name">速度：</span>
                <span class="tips-content">{{speed}}/s</span>
            </div>
            <div class="progress-tips">
                <span class="tips-name">剩余时间：</span>
                <span class="tips-content">{{waitTime}}</span>
            </div>
            <div class="progress-tips">
                <span class="tips-name">进度：</span>
                <span class="tips-content">{{progressBar}}%</span>
            </div>
        </div>
        <!-- 视频上传中的状态 ]] -->

        <!-- 视频上传后的状态 -->
        <div class="video-uploading-block" 
            v-loading="loading" 
            v-show="uploadStatus == 3"
            element-loading-spinner="el-icon-loading">
            <div class="video-name">{{fileName}}</div>
            <!-- <video class="f-hide" ref="videoRef" :src="videoUrlHttp+'?id='+videoId" width="200" height="150">
            </video> -->
            <video class="f-hide" ref="videoRef" :src="previewUrl" width="200" height="150" controls>
                <!-- <source src="~Assets/img/v1.mp4" type="video/mp4" /> -->
                当前浏览器不支持 video直接播放
            </video>
            <div class="progress-content">
                <div class="progress-bar">
                    <div class="bar" :style="{width: progressBar+'%'}"></div>
                    <div class="progress"></div>
                </div>
                <a href="javascript:;" class="g-btn video-cancel" @click="delVideo()">取消</a>
            </div>
            <div class="progress-tips">
                <span class="tips-name">进度：</span>
                <span class="tips-content">{{progressBar}}%</span>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/order/contribution.scss';
    @import  '~Assets/sass/pages/v4/order/order.scss';
    @import '~Assets/sass/pages/v4/order/order_contribute.scss';
    .video-uploading-block{
        position: relative;
    }
    .shacurr{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background: rgba(255,255,255,.7);
        font-size: 16px;
        color: #333;
        text-align: center;
        line-height: 100px;
    }
    .bar{
        transition: linear 0.1s;
    }
</style>
<script>
import videoUploadUgc from 'Mixins/videoUploadUgc';
export default {
    mixins: [videoUploadUgc]
}
</script>